import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AddShiftResponse } from '@api/src/models/AgentApi/Contract/add-shift-response';
import { RouteEntity } from '@core/router/route.entity';
import { UserState } from '@core/user/user.state';
import { map } from 'rxjs/operators';


export const needShiftGuard: CanActivateFn = () => {
    const userState: UserState = inject(UserState);
    const router: Router = inject(Router);

    return userState.shift$.pipe(
        map((shift: AddShiftResponse) => {
            if (!shift) {
                const shiftUrl = router.parseUrl(RouteEntity.Root + RouteEntity.Shift);

                return new RedirectCommand(shiftUrl, {
                    skipLocationChange: true,
                });
            }

            return true;
        }),
    );
};
